import { CustomRouteObject } from '../../types/routes/Route.type';
import UserDashBoard from '../../pages/UserDashBoard';
import MainLayout from '../../layouts/MainLayout';
import Login from '../../pages/Login';
import OAuthPage from '../../pages/OAuthPage';
import UserInfoPage from '../../pages/UserInfoPage';

const user: CustomRouteObject = {
  id: 'userRoot',
  path: '/user',
  element: <MainLayout />,
  children: [
    {
      id: 'userDashboard',
      path: 'dashboard',
      element: <UserDashBoard />,
    },
    {
      id: 'login',
      path: 'login',
      element: <Login />,
    },
    {
      id: 'oauth',
      path: 'oauth-response/:token/:expirationTime',
      element: <OAuthPage />,
    },
    {
      id: 'userInfo',
      path: 'info/:userId',
      element: <UserInfoPage />,
    },
  ],
};

export default user;
